var Locale;!function(a){a.DK="dk",a.SE="se"}(Locale=Locale||{});var Locale$1=Locale;export default Locale;
